import { useQuery } from 'react-query';

import { status200 } from '../status.utils';
import axios from '../axios/axiosInstance';
import apiPaths from '../apiPaths';
import {useAuth} from "../../components/providers/AuthProvider";


const fetchCartoPiaToken = async () => {
  const token = localStorage.getItem("accessToken");
  return axios.get(apiPaths.refreshCartoPiaToken, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }).then(res => res.data);
}


const useCartoPiaToken = () =>{
  const {isAuthenticated} = useAuth();
  return useQuery('carto-pia-token', () => fetchCartoPiaToken(), {
    refetchOnWindowFocus: false,
    cacheTime: 0,
    enabled: isAuthenticated,
  });
}


export default useCartoPiaToken;
